import { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';
import type { Game } from '@/types/games';
import type { ClientGameContext } from './client-game-context';
import { parseGamesList } from './parse-games-list';

/** Adapts search result games — animated tiles are always disabled in search. */
export const parseSearchGames = (games: Game[], ctx: ClientGameContext) =>
    parseGamesList(games, PRISMIC_ZONE_LAYOUT.DEFAULT, ctx, { disableAnimatedTiles: true });
